import { render, staticRenderFns } from "./NonEditableSubcontract.vue?vue&type=template&id=a137a678&scoped=true&"
import script from "./NonEditableSubcontract.vue?vue&type=script&lang=js&"
export * from "./NonEditableSubcontract.vue?vue&type=script&lang=js&"
import style0 from "./NonEditableSubcontract.vue?vue&type=style&index=0&id=a137a678&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a137a678",
  null
  
)

export default component.exports